
export function getTitle(titleID) {
  return titleID === '02' ? 'Prof.' : titleID === '01' ? 'Dr.' : titleID === '03' ? 'Prof. Dr.': '';
}

export function getSalutation(salutationID) {
  return salutationID === '01' ? 'Frau' : salutationID === '03' ? 'Firma' : 'Herr'
}

export function getName(state) {
  if(state.salutation === '03'){
    return state.companyName
  }
  return getTitle(state.title) + " " + state.firstname + " " + state.lastname
}


// WEBPACK FOOTER //
// ./src/components/TitlePrinter.js